import React from 'react';

const GameGiftCollect = () => {
    return (
        <div>
            <h3>Collect Christmas Gifts játék</h3>
            <iframe src="cdn/apps/collect_christmas_gifts/index.html" frameBorder="0"
                    className={'max-w-96 max-h-56 my-5 md:hidden'}/>
            <iframe src="cdn/apps/collect_christmas_gifts/index.html" width='683' height='384' frameBorder="0"
                    className={'max-w-screen-md max-h-96 my-5 hidden md:block'}/>
        </div>
    );
};

export default GameGiftCollect;
